module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/address-link.c04ca2d6.svg";